
export default {
  props: {
    figuresmsError: {
      type: [Number, String],
      default: ''
    },
    phone: {
      type: [Number, String],
      default: '未传入手机号'
    },
    areaCode: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      smsState: false,
      sms: '',
      graphicalImg: ''
    }
  },
  created() {},
  mounted() {
    this.nextstep()
  },
  methods: {
    async nextstep() {
      const result = await this.$api.common
        .CV3(
          {
            areaCode: this.areaCode,
            userId: this.userId,
            phonenumber: this.phone,
            length: 4,
            width: 112,
            heigth: 50
          },
          {
            Routes: 'usercenter$getgraphcode'
          }
        )
        .catch(() => {
          console.log('getgraphcode')
        })
      if (result && result.usercenter && result.usercenter.getgraphcode && result.usercenter.getgraphcode.success) {
        this.graphicalImg = result.usercenter.getgraphcode.data
      }
    }
  }
}
